module.exports = __webpack_public_path__ + "img/therapist.5014031c.png";